import { IQuote } from "src/app/chats-panel/~store/state/ChatItemsState";

export const formatQuotationMessage = (quote: IQuote, messageText: string): string => {
    if (!quote.author) {
        return `>${quote.text.replace("^>/g", "")}\n\n${messageText}`;
    }
    const quoteText = quote.author ?
        `>${quote.author}:  \n${quote.text.replace("^>/g", "")}` :
        `>${quote.text.replace("^>/g", "")}`;
    return `${quoteText}\n\n${messageText}`;
}

const MAX_QUOTE_LENGTH = 50;
export const formatQuote = (quote: string): string => {
    if (quote.length <= MAX_QUOTE_LENGTH) {
        return quote;
    }

    quote = quote.slice(0, MAX_QUOTE_LENGTH);
    quote += "..."
    return quote;
}